module.exports={render:function (){with(this) {
  return _h('div', {
    class: ("modal " + (wide ? 'wide' : ''))
  }, [_t("default")])
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-06d8f15c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
 ** module id = 163
 ** module chunks = 2
 **/